import { Box, ClearIcon } from '@modusign/design-system';

export default function InputClearButton({ onClick }: { onClick: () => void }) {
  return (
    <Box
      aria-label="입력값 비우기"
      as="button"
      height={'calc(100% - 2px)'}
      mr={2}
      type="button"
      onClick={onClick}
    >
      <ClearIcon
        color="iconNeutralSlightlyLight"
        sx={{
          '&:hover': { color: 'iconNeutralBase' },
        }}
      />
    </Box>
  );
}
